<template>
  <img src="@/../../web/img/system/checked_no.png" />
</template>

<script>
export default {
  name: 'IconUnchecked',
}
</script>
